import React from 'react';
import { Box } from '@chakra-ui/react';
import { Campaign, Client, Collab } from '@foodfluence/shared';
import BottomSheet from '../../collabs/components/BottomSheet';
import RequestCollabForm from './RequestCollabForm';
import { PitchType } from './PitchCollabSheet';

interface RequestCollabModalProps {
  isOpen: boolean;
  onClose: () => void;
  campaign?: Campaign | null;
  client: Client | null;
  requestedCollab?: Collab | null;
  /** Custom requests: what the creator chose to pitch in the Pitch a collab sheet */
  pitchType?: PitchType;
  /** Open with the compensation inputs in view ("Counter-offer"). */
  scrollToCompensation?: boolean;
  initialSelectedLocationIds?: string[];
}

/**
 * Request-collab flow in a bottom sheet over the current page (campaign page, brand page,
 * explore feed), so closing it returns the user to exactly where they were.
 */
const RequestCollabModal: React.FC<RequestCollabModalProps> = ({
  isOpen,
  onClose,
  campaign = null,
  client,
  requestedCollab = null,
  pitchType,
  scrollToCompensation = false,
  initialSelectedLocationIds,
}) => (
  <BottomSheet isOpen={isOpen} onClose={onClose} maxH="94vh">
    <Box flex={1} minH={0} overflowY="auto" bg="white">
      <RequestCollabForm
        campaign={campaign}
        client={client}
        requestedCollab={requestedCollab}
        pitchType={pitchType}
        onExit={onClose}
        inModal
        scrollToCompensation={scrollToCompensation}
        initialSelectedLocationIds={initialSelectedLocationIds}
      />
    </Box>
  </BottomSheet>
);

export default RequestCollabModal;
